<template>
	<div
		id="app"
		v-shortkey="keyBinds"
		@shortkey="keyActions"
	>
		<menu-bar />
		<transition
			:name="$settings.routerAnimation"
			mode="out-in"
		>
			<router-view id="content" />
		</transition>

		<cordova />
		<css-debug />
		<env-bar />
		<dev-sidebar />
	</div>
</template>

<script>
import MenuBar from '@/system/layouts/app/menuBar';
import DevSidebar from '@/system/layouts/app/sidebar/developer';
import Cordova from '@/system/layouts/public/cordova';
import CssDebug from '@/system/layouts/public/css-debug';
import EnvBar from '@/system/layouts/public/env-bar';

export default {
	name: 'App',
	components: {
		MenuBar,
		Cordova,
		DevSidebar,
		CssDebug,
		EnvBar
	},
	data() {
		return {
			keyBinds: {
				toggleSettings: ['ctrl', 'alt', 's'],
				toggleDevSettings: ['ctrl', 'alt', 'd']
			}
		};
	},
	computed: {
		dark() {
			return this.$settings.dark;
		}
	},
	watch: {
		dark() {
			this.setTheme();
		}
	},
	created() {
		this.setTheme();
	},
	methods: {
		keyActions(event) {
			switch (event.srcKey) {
				case 'toggleSettings':
					this.$hub.$emit('_toggleSettings');
					break;
				case 'toggleDevSettings':
					this.$hub.$emit('_toggleDevSettings');
					break;

				default:
			}
		},
		setTheme() {
			let theme = 'default';
			if (this.$settings.dark === true) theme = 'dark';
			document.getElementsByTagName('html')[0].setAttribute('data-kit-theme', theme);
		}
	}
};
</script>
